


































import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { SignDigitalSignatureRequestSignerViewModelGen } from "@/services/sign/v1/data-contracts";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import SignFormEditor from "./SignFormEditor.vue";
import SignFormEditorMobile from "./SignFormEditorMobile.vue";

@Component({
  components: { ConfirmActionDialog },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class SignFormDialog extends Vue {
  @Prop()
  signRequest!: SignDigitalSignatureRequestSignerViewModelGen;

  @Prop()
  signFormEditor?: (SignFormEditor | SignFormEditorMobile)[];

  isDialogActive = false;

  get companyName() {
    return this.partner.companyName;
  }

  get partner() {
    return ReportModule.partner;
  }

  proceed() {
    if (this.signFormEditor) {
      // in hopes that this solves an issue where the select box on iphone is not shown
      this.signFormEditor[0].detailCardEditor?.selector?.resize();
    }

    this.$emit("confirmed");
    this.isDialogActive = false;
  }

  mounted() {
    this.isDialogActive = true;
  }
}
